import script from "./sidebar-link.vue?vue&type=script&lang=js"
export * from "./sidebar-link.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/layouts/partials/sidebar-link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "792a59ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('792a59ee', __exports__)) {
    console.log('reload')
    api.reload('792a59ee', __exports__)
  }
  
}


export default __exports__